import { deleteCameraType1 } from "actions/Utilities/CameraType1";
import { toast } from "components/toastNotification";
import React from "react";
import { useMutation } from "react-query";
import { useRecoilState } from "recoil";
import { cameraType1ReFetching } from "../atoms/atoms";

export default function useDeleteCameraType1() {
  const [isReFetching, setIsReFetching] = useRecoilState(cameraType1ReFetching);

  const { mutate } = useMutation((ids: number[]) => deleteCameraType1(ids), {
    onSuccess: (res: any) => {
      if (typeof res == "object") {
        toast.fire("Disabling Camera Type 1 failed", res.Message, "error");
      } else {
        switch (true) {
          case res == "Success":
            toast.fire(
              "Success",
              "Camera Type 1 Disabled Successfully",
              "success"
            );
            break;
          case res.includes("Notification insert Failed"):
            toast.fire(
              "Success ",
              `Camera Type 1 Disabled Successfully, BUT ${res}`,
              "warning"
            );
            break;
          case res == "Operation Failed!":
            toast.fire(
              "Disabling Camera Type 1 failed ",
              `Server Error: ${res}`,
              "error"
            );
            break;
          case res == "Camera Type 1 not found":
            toast.fire(
              "Disabling Camera Type 1 failed ",
              `Error: ${res}`,
              "error"
            );
            break;
          default:
            toast.fire("Disabling Camera Type 1 failed", res, "error");
        }
      }
      // ReFetch Data
      setIsReFetching(isReFetching ? false : true);
    },
    onError: (error) => {
      toast.fire("Disabling Camera Type 1 failed", `Error: ${error}`, "error");
    },
  });

  return mutate;
}
